import AccountForm from 'components/account-form/AccountForm'

const MyAccountPage = () => {
  return (
    <div style={{ height: '100%' }} className="my-account-page-inner">
      <AccountForm />
    </div>
  )
}

export default MyAccountPage
